import { MAJORCLARITY_SIGNOUT_PATH } from './constants'
import { isAuth0AuthenticatedMajorClarityUser } from './authenticationHelpers'
import { AUTH0_USER_LOGOUT_URL } from './auth0Config'

class LogoutService {
  public initializeLogoutEventListener(): this {
    const signOutLink = $('.nav-item-sign-out a')

    if (signOutLink.length) {
      document.addEventListener('DOMContentLoaded', () => {
        signOutLink[0].addEventListener('click', async (event) => {
          event.preventDefault()

          try {
            if (isAuth0AuthenticatedMajorClarityUser()) {
              await this.userAuth0SignOut()
            }
          } catch (e) {
            console.log(e)
          } finally {
            window.location.replace(MAJORCLARITY_SIGNOUT_PATH)
          }
        })
      })
    }

    return this
  }

  private async userAuth0SignOut(): Promise<void> {
    try {
      await fetch(AUTH0_USER_LOGOUT_URL, {
        method: 'GET',
        mode: 'no-cors'
      })
    } catch (error) {
      console.error('Error occurred during logout:', error)
    }
  }
}

export default LogoutService
